import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = ({ component, auth, path, exact = false }: any) => {
	const authenticated = !!auth?.user?.email;
	return authenticated ? <Route component={component} exact={exact} path={path} auth={auth} /> : <Redirect to={'/login'} />;
};

export default ProtectedRoute;
